import { render } from "./PricingActiveIcon.vue?vue&type=template&id=13ba1b5e"
import script from "./PricingActiveIcon.vue?vue&type=script&lang=js"
export * from "./PricingActiveIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__